// const API_URL = 'https://nexus-backend-prod-i7d22.ondigitalocean.app';
const API_URL = 'https://nexus-backend-prod-2-nrm4g.ondigitalocean.app';


// const GOOGLE_API_KEY = '719890144757-g0945lggc9lldjbkmptj90rd4cnc616f.apps.googleusercontent.com'
const GOOGLE_API_KEY = '233123358987-40ep0hma117kpt8q7lng5uic9a3bdrbs.apps.googleusercontent.com'
// const GOOGLE_API_KEY = '46215792346-5dgudvn6huu44agq52in5ih27b8c8l36.apps.googleusercontent.com'


// const HEADERS_API = {
//   'X-Api-Key': 'd2g4c3e8a62b9d15x19c4ac6b67cfa127b1Y75a8a80106e276812734cb6c55e8',
//   "Content-Type": "application/json",
// }

// Helper to read a cookie value by name
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

// Function to build headers (reads JWT from cookie)
const getHeaders = () => {
  const token = getCookie("_GRE_JWT_TOKEN"); // read token from cookie

  return {
    "X-Api-Key": "d2g4c3e8a62b9d15x19c4ac6b67cfa127b1Y75a8a80106e276812734cb6c55e8",
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }), // only add header if token exists
  };
};

// Function to always fetch latest token
// const getHeaders = () => {
//   const token = localStorage.getItem('_register_GRE_LOGIN_JWT_TOKEN');
//   return {
//     'X-Api-Key': 'd2g4c3e8a62b9d15x19c4ac6b67cfa127b1Y75a8a80106e276812734cb6c55e8',
//     'Content-Type': 'application/json',
//     Authorization: token ? `Bearer ${token}` : '',
//   };
// };

export {
  API_URL,
  // HEADERS_API,
  getHeaders,
  getCookie,
  GOOGLE_API_KEY
}
